"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _mapDeep = _interopRequireDefault(require("./map-deep"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const keysToCamelCaseDeep = data => (0, _mapDeep.default)(data, (_value, key) => ({
  key: (0, _lodash.isString)(key) ? (0, _lodash.camelCase)(key) : key
}));

var _default = keysToCamelCaseDeep;
exports.default = _default;